import axios from "@/plugins/Axios";

const model = "dof-dependencies";

function all() {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}`);
}

function find(id) {
  return axios.get(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

function create(dependency) {
  return axios.post(`${process.env.VUE_APP_API_URL}/${model}`, dependency);
}

function update(id, dependency) {
  return axios.put(`${process.env.VUE_APP_API_URL}/${model}/${id}`, dependency);
}

function remove(id) {
  return axios.delete(`${process.env.VUE_APP_API_URL}/${model}/${id}`);
}

export { all, find, create, update, remove };
